import React from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { walletState } from "stores/reducers/wallet/selectors";
import { walletActions } from "stores/reducers/wallet";
import { truncateWalletAddress } from "utils/truncateWalletAddress";
import { modalActions } from "stores/reducers/modal";
import ConnectWalletModal from "components/Modal/ConnectWalletModal";
import { showConnectWalletModalState } from "stores/reducers/modal/selectors";
import { toast } from "react-toastify";
import { ReactComponent as WalletIcon } from "assets/wallet.svg";
import { useTranslation } from "react-i18next";

const ConnectWallet = () => {
  const { t, i18n } = useTranslation();
  
  const wallet = useSelector(walletState);

  const showConnectWalletModal = useSelector(showConnectWalletModalState);

  const dispatch = useDispatch();

  return (
    <>
      {wallet.status === "DISCONNECTED" ? (
        <ConnectButton
          type="button"
          onClick={() => {
            dispatch(modalActions.toggleConnectWalletModal(true));
          }}
        >
          {t('CONNECT_WALLET')}
        </ConnectButton>
      ) : (
        <ConnectedInfo
          onClick={() => {
            dispatch(walletActions.resetWalletState());
            toast.warning("Wallet disconnected", {});
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              whiteSpace: "nowrap",
            }}
          >
            <WalletIcon width={14} height={14} />
            {parseFloat(wallet.balance.toString()).toFixed(6)} BNB
          </div>
          <div>{truncateWalletAddress(wallet.address)}</div>
        </ConnectedInfo>
      )}

      <ConnectWalletModal
        isOpen={showConnectWalletModal || false}
        setOpen={() => dispatch(modalActions.toggleConnectWalletModal(false))}
        handleSelectWallet={() => console.log("Connect")}
      />
    </>
  );
};

export default ConnectWallet;

const ConnectButton = styled.button`
  border-radius: 14px;
  background: ${(p) => p.theme.subColor};
  color: #fff;
  padding: 0.5rem;
  transition: 0.275s;
  cursor: pointer;
  width: 200px;
  border: none;

  &:hover {
    opacity: 0.8;
  }
`;

const ConnectedInfo = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 1rem;

  background: ${(p) => p.theme.subColor};
  border-radius: 14px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: 0.5s;

  min-width: 280px;
  justify-content: space-between;

  &:hover {
    opacity: 0.8;

    &:before {
      content: "Disconnect Wallet";
      position: relative;
      top: 10px;
      background: white;
      content: "Disconnect Wallet";
      position: absolute;
      padding: 0.25rem 1rem;
      border-radius: 8px;
      transition: 0.5s;
      color: ${(p) => p.theme.secondary};
      top: 80px;
    }
  }

  @media (max-width: 1024px) {
    min-width: unset;
    grid-gap: 4px;
    display: block;
    svg {
      display: none;
    }
  }
`;
